import styled from 'styled-components';

import { Title } from '@yoweb/ui/components/typography';
import { getSpace } from '@yoweb/ui/styles/utils/theme';

export const H2Legal = styled(Title)`
  && {
    margin-top: ${getSpace('normal2')};
  }
`;

H2Legal.defaultProps = {
  size: 'sm',
  as: 'h2',
};
